import React,{useEffect,useState ,useMemo} from 'react';
import caretapLogo from '../assets/images/care-tap.png';
import profileLogo from '../assets/images/user.png';
import { useNavigate } from "react-router-dom";
import MenuBar from './MenuBar';
import {capitalizeFirstLetter} from "../utils"
import { useLocation,Link    } from 'react-router-dom';

const Header = () =>{
  const navigate = useNavigate();
  const [key, setKey] = useState(0);
  const [title, setTitle] = useState('DashBoard');
  const location = useLocation();
    const currentUrl = location.pathname;
    const urlAfterHome = currentUrl.split('/home/')[1];
    const urlSegments = currentUrl.split('/');
  const lastName = urlSegments[urlSegments.length - 1];
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('userData')));
  useEffect(() => {
    const prefix = process.env.REACT_APP_TITLE || 'CaretapTransportation';
  document.title = `${prefix} | ${title}`;
  }, [title]);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition >= 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array means this effect runs once when component mounts

let router='';
  const handleMenuItemClick = useMemo(() => (title, route) => {
    router = route;
    if(urlAfterHome === route){
      window.location.reload();

    }
    setTitle(title);
    navigate(`/home/${route}`, { replace: false }); // navigate to absolute path
    setKey(prevKey => prevKey + 1); // Update the key to force re-render
  }, [navigate]);

  const handleLogout = ()=>{
    localStorage.removeItem('userData');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshtoken');
        localStorage.removeItem('pdfDetails');
        localStorage.removeItem('myArray');
        navigate('/');
  }

  const handleChatClick = () => {
    handleMenuItemClick('Chat', 'chat');
  }

return(
    <header>
    <div className="header-wrapper">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center pt-4 mx-md-5">
          <div className="d-mobile-none">
            <img src={caretapLogo} width="180" height="180" alt="care-tap" className="img-fluid" />
          </div>
          <div className='d-flex align-items-center gap-2'>
              <div>
                <h1 className="text-white mb-0 fs-5">Welcome {capitalizeFirstLetter(userData?.full_name || userData?.first_name + ' '+ userData?.middle_name + ' ' + userData?.last_name) + ' (' + userData?.agency_id + ')' }</h1>
              </div>
              <div className="d-flex align-items-center gap-3">
                {/* Chat Icon Button - Overlapping Message Icons Without Background */}
                <button 
                  className="btn bg-transparent border-0 text-white" 
                  type="button" 
                  onClick={handleChatClick}
                  title="Messages"
                  style={{ 
                    padding: '0.5rem', 
                    cursor: 'pointer', 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    marginRight: '0.5rem',
                    background: 'transparent',
                    border: 'none',
                    transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    position: 'relative',
                    overflow: 'visible'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  }}
                >
                  {/* Two Overlapping Message Icons - Premium Elevation Effect */}
                  <div style={{
                    position: 'relative',
                    width: '38px',
                    height: '38px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    perspective: '120px'
                  }}>
                    {/* Back bubble - white, positioned left and slightly down, pushed back */}
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="30" 
                      height="30" 
                      viewBox="0 0 24 24" 
                      style={{ 
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-72%, -45%) scale(0.92)',
                        zIndex: 1,
                        opacity: 0.95,
                        filter: 'drop-shadow(0 2px 3px rgba(0, 0, 0, 0.12)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.08))'
                      }}
                    >
                      <defs>
                        <linearGradient id="backBubbleWhite" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" style={{stopColor: 'rgba(255, 255, 255, 1)', stopOpacity: 1}} />
                          <stop offset="50%" style={{stopColor: 'rgba(255, 255, 255, 0.98)', stopOpacity: 1}} />
                          <stop offset="100%" style={{stopColor: 'rgba(255, 255, 255, 0.95)', stopOpacity: 1}} />
                        </linearGradient>
                      </defs>
                      <path 
                        d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" 
                        fill="url(#backBubbleWhite)"
                        stroke="rgba(255, 255, 255, 0.8)"
                        strokeWidth="0.8"
                      />
                    </svg>
                    
                    {/* Front bubble - white, positioned right and slightly up, elevated with premium shadow */}
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="30" 
                      height="30" 
                      viewBox="0 0 24 24" 
                      style={{ 
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-28%, -55%) scale(1.08)',
                        zIndex: 3,
                        filter: 'drop-shadow(0 5px 10px rgba(0, 0, 0, 0.35)) drop-shadow(0 3px 6px rgba(0, 0, 0, 0.25)) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15)) drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2))'
                      }}
                    >
                      <defs>
                        <linearGradient id="frontBubbleWhite" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" style={{stopColor: 'rgba(255, 255, 255, 1)', stopOpacity: 1}} />
                          <stop offset="30%" style={{stopColor: 'rgba(255, 255, 255, 0.99)', stopOpacity: 1}} />
                          <stop offset="70%" style={{stopColor: 'rgba(255, 255, 255, 0.97)', stopOpacity: 1}} />
                          <stop offset="100%" style={{stopColor: 'rgba(255, 255, 255, 0.95)', stopOpacity: 1}} />
                        </linearGradient>
                        <linearGradient id="frontBubbleHighlight" x1="0%" y1="0%" x2="0%" y2="100%">
                          <stop offset="0%" style={{stopColor: 'rgba(255, 255, 255, 0.4)', stopOpacity: 1}} />
                          <stop offset="100%" style={{stopColor: 'rgba(255, 255, 255, 0)', stopOpacity: 1}} />
                        </linearGradient>
                      </defs>
                      <path 
                        d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" 
                        fill="url(#frontBubbleWhite)"
                        stroke="rgba(255, 255, 255, 0.95)"
                        strokeWidth="1.8"
                      />
                      {/* Subtle inner highlight for premium look */}
                      <path 
                        d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" 
                        fill="url(#frontBubbleHighlight)"
                        stroke="none"
                        opacity="0.6"
                      />
                  </svg>
                  </div>
                </button>
                {/* Settings Dropdown */}
                <div className="dropdown">
                  <button className="btn bg-transparent border-0 dropdown-toggle text-white" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" className="bi bi-gear" viewBox="0 0 16 16">
                    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
                  </svg>
                  </button>
                  <ul className="dropdown-menu profile-icon" aria-labelledby="dropdownMenuButton1">
                    <li><Link className="dropdown-item" to="/home/profile/myProfile">My Account</Link></li>
                    <li><Link className="dropdown-item" to="/home/billing/configuration">Billing Configuration</Link></li>
                    <li><a className="dropdown-item" onClick={handleLogout}>Log Out</a></li>
                  </ul>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div className={`nav-main ${isSticky ? "custom-sticky" : ""}`}>
      <div>
      <MenuBar onClick={handleMenuItemClick} userRole={userData?.user_role}   />
       
      </div>
    </div>
  </header>
);
}
export default Header;